import { useMutation, useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";
import { TalhaoJustificados } from "../interfaces/Talhao";

export type TalhoesJustificadosResponse = TalhaoJustificados;

export function useTalhaoJustificativa(filters?: any) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_OPERACAO_TALHAO_JUSTIFICATIVA, filters],
    async () => {
      const response = await http.get<TalhaoJustificados[]>(URL.PLANO_OPERACIONAL.OBTER_OPERACAO_TALHAO_JUSTIFICATIVA, {
        params: filters,
      });
      return {
        data: response.data,
        headers: response.headers,
      };
    },
    {
      keepPreviousData: true,
      enabled: !!filters,
    }
  );
}

export function useTalhaoJustificativaUpdate() {
   return useMutation(async ({ body }: { body: any }) => {
      const response = await http.put(URL.PLANO_OPERACIONAL.OBTER_OPERACAO_TALHAO_JUSTIFICATIVA_ATUALIZAR, body);
      return response;
  });
}
